exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.sponsers-slick .slick-dots{\n  bottom: -35px;\n}\n.sponsers-slick{\n  margin-bottom:0px;\n}\n.sponsers-slick .slick-slide{\n  border-right:0px;\n}\n", ""]);

// exports
